import { jsx as _jsx } from "react/jsx-runtime";
import { useLocalStorageState } from "@sundae/react-hooks";
import { createContext, useCallback, useContext, useReducer, } from "react";
import { PERSISTENT_STORAGE_KEY } from "../../components/Forms/CreateProposalForm/constants";
import { appReducer } from "./reducer";
import { EAppActions } from "./types";
export const defaultAppState = {
    config: null,
    componentProps: {},
    bgImage: "",
    exchange: {
        assetSelectContext: null,
        assetSelectOpen: false,
        inputValue: null,
        outputValue: null,
    },
    offCanvasOpen: false,
    walletConnectOpen: false,
    networkOpen: false,
    errorReportingEnabled: true,
};
const AppContext = createContext({
    state: defaultAppState,
    dispatch: () => { },
});
export const AppContextProvider = ({ children, config, componentProps, bgImage }) => {
    const [savedState, saveState] = useLocalStorageState(PERSISTENT_STORAGE_KEY, {
        errorReportingEnabled: true,
    });
    const persistentReducer = useCallback((prevState, action) => {
        const state = appReducer(prevState, action);
        if (action.type === EAppActions.SET_ERROR_REPORTING_ENABLED) {
            saveState({
                errorReportingEnabled: state.errorReportingEnabled,
            });
        }
        return state;
    }, [saveState]);
    const [state, dispatch] = useReducer(persistentReducer, {
        ...defaultAppState,
        config,
        componentProps,
        bgImage,
        errorReportingEnabled: savedState?.errorReportingEnabled ?? false,
    });
    return _jsx(AppContext.Provider, { value: { state, dispatch }, children: children });
};
// Utility hook.
export const useAppContext = () => useContext(AppContext);
//# sourceMappingURL=context.js.map